//import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar,IconButton, Toolbar } from '@mui/material';

// project import
//import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import { useMediaQuery } from '@mui/material';
// assets
import { CaretLeftOutlined } from '@ant-design/icons';
import { backgroundColor } from 'utils/constants';
import { useLocation } from 'react-router-dom';
import React from 'react';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({hideOnPendingOrder, hidebackIcon, handleDrawerToggle}) => {
  const theme = useTheme();
  ///const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const currentPath = location.pathname;
  const iconBackColor = 'grey.100';
  //const iconBackColorOpen = 'grey.200';
  const customer = JSON.parse(localStorage.getItem('headerCustomer'));
  const distibutor = JSON.parse(localStorage.getItem('distributorName'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const user = JSON.parse(localStorage.getItem('user'));
  const orderNumberString = localStorage.getItem('showordernumber');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // console.log("orderNumberString",orderNumberString);
  // common header
  const mainHeader = (
    <Toolbar className={'header-MuiToolbar-root'}
    
    >
      {hideOnPendingOrder ? (
        <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          sx={{ color: 'text.primary', bgcolor: iconBackColor, ml: { xs: 0, lg: -2 } }}
        >
          {<CaretLeftOutlined />}
        </IconButton>
      ) : (
        <span></span>
      )}
{/* <span></span> */}
      <div style={{ marginLeft: isMobile ? '15%' : '5%' }} className="header">
        {(currentPath === '/productBookingf' || currentPath === '/saleorderdetails' || currentPath === '/productBookingg') &&
        orderNumberString !== '0' ? (
          <div style={{ textAlign: 'center' }}>
            <span>{'Order Number' + ' : ' + orderNumberString}</span>
          </div>
        ) : null}

        {currentPath !== '/dashboard' && currentPath !== '/salesorder' && currentPath !== '/myordersreport' ? (
          <div style={{ textAlign: 'center' }}>
            <span style={{ marginRight: '10px' }}>{customer?.partyName}</span>
            <span>{user.userName}</span>
            <br />
            <span style={{ marginRight: '10px' }}>{distibutor == 'undefined' || distibutor == null ? '' : distibutor}</span>
            <span>{confvalue.label}</span>
          </div>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <span>{user.userName}</span>
            <br />
            <span>{confvalue.label}</span>
          </div>
        )}
      </div>

      <HeaderContent />
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: backgroundColor,
      width: { xs: '100%', lg: hideOnPendingOrder ? '100%' : 'calc(100% - 250px)'  },
    ml: { xs: 0, lg: '250px' }
      // boxShadow: theme.customShadows.z1
    }
  };

  return (
    <>
      <AppBar  {...appBar} >{mainHeader}</AppBar>
    </>
  );
};

export default Header;
